// Safely add/remove classes on a (possibly missing) element inside a root.
// BazaarVoice hashed class names are not guaranteed to exist, so an
// unguarded querySelector(...).classList threw "Cannot read properties of
// null (reading 'classList')". This no-ops when the element is absent.
function bvSafeClass(root, selector, action, classes){
  if(!root) return;
  var node = root.querySelector(selector);
  if(!node || !node.classList) return;
  node.classList[action].apply(node.classList, classes);
}

document.addEventListener('DOMContentLoaded', ()=>{
  const observer = new MutationObserver((mutationsList, observer)=>{
    const form = document.querySelector('#app-embed');
    if(form){
      const shadow = form.shadowRoot;
      if(shadow){
        observer.disconnect();
        const header = shadow.querySelector("._textHeading_2aowh_35");
        const el = shadow.querySelector('._textBody_2aowh_10._checkboxLegend_1hja3_20');
        const container_section = shadow.querySelector('._formContainer_1q1d2_30._grid_1q1d2_148._noImage_1q1d2_161');
        const btn = shadow.querySelector('._formSubmitButton_cit2d_96');
        const parentDiv = shadow.querySelector('._formFieldset_cit2d_82');
        const newDiv = document.createElement("div");
        newDiv.innerHTML = "<p style='color: black;'>Our database will be updated to reflect your request. Please allow up to 10 business days for email and up to 3 months for Direct Mail for your preferences to take effect. Because some communications, such as direct mail catalogues, are developed and queued for distribution well in advance, you may receive additional information after we receive your request. For information on Greenworks Tools' policy on the protection of your personal data, see our <a href=\"https://www.greenworkstools.com/pages/privacy-policy\">Privacy Statement</a>.</p>";
        if (el){
          el.style.display = 'none';
        }
        if (container_section){
          container_section.setAttribute("style", "max-width: 70%;");
        }
        if(btn){
          btn.setAttribute('style', 'background-color: #046A38;');
        }
        if (parentDiv){
          if (header.innerHTML == "List Removal"){
            parentDiv.insertBefore(newDiv, btn);
          }else if(header.innerHTML == "Authorized Agent Designation"){
            const firstName_input = shadow.querySelector('#first_name');
            const form_container_ref = shadow.querySelector('#form-container-ref');
            const dropdown4 = shadow.querySelector('[aria-controls="custom#requests_to_know_about_personal_information_greenworks_tools_has-selector-dropdown"]');
            dropdown4.previousElementSibling.innerHTML = "By signing below, I authorize the authorized agent identified above to make the following requests on my behalf: ";
            const agent_firstName_input_id = "custom#authorized_agent_first_name";
            const agent_firstName_input = shadow.querySelector(`#${CSS.escape(agent_firstName_input_id)}`)
            const aac = shadow.querySelector('[aria-controls="custom#authorized_agent-selector-dropdown"]')
            const subHeader1_div = document.createElement("div");
            const subHeader2_div = document.createElement("div");
            const description_div = document.createElement("div");
            const description2_div = document.createElement("div");
            subHeader1_div.innerHTML = "<h3 style='color: black;'>Customer / Client</h3>";
            subHeader2_div.innerHTML = "<h3 style='color: black;'>Authorized Agent Designation Form</h3> <p style='color: black;'>Fill out the your information as Authorized Agent.</p>"; 
            description_div.innerHTML = "<p style='color: black;'>The California Consumer Privacy Act permits California residents to designate an authorized agent to submit a request to delete personal information or a request to know about personal information collected by a business. An authorized agent may be either a natural person or a business entity registered with the Secretary of State to conduct business in California. You can initiate the process of designating an authorized agent by completing and submitting this form to us at privacy@greenworkstools.com or by calling 1-888-909-6757 . We may request additional supporting documentation if necessary and may require the authorized agent to provide appropriate legal documentation demonstrating permission to request personal data on behalf of a California resident. Authorized agents with a power of attorney may submit requests directly on behalf of that consumer without submitting this form but the authorized agent may be required to submit evidence of the power of attorney. <br> <br> Once you have authorized a natural person or business entity to act on your behalf, you can revoke their designation as an authorized agent (Monday through Friday from 8:00 a.m. to 8:00 p.m) by contacting us at 1-888-909-6757. <br> <br> Please note that we may contact you directly to verify your identity. We will deny a request from an agent who is not authorized by you to make a request. We also will deny a request from an agent who does not provide sufficient evidence to demonstrate that it has permission to request personal information on your behalf.</p>";
            description2_div.innerHTML = "<p style='color: black;'>If the person you wish to designate as an authorized agent is a business entity, we may request further information regarding the business entity’s registration with the Secretary of State to conduct business in California.</p>";
            firstName_input.parentNode.parentNode.insertBefore(subHeader1_div, firstName_input.parentNode);
            agent_firstName_input.parentNode.parentNode.insertBefore(subHeader2_div, agent_firstName_input.parentNode);
            form_container_ref.parentNode.insertBefore(description_div, form_container_ref);
            aac.parentNode.parentNode.insertBefore(description2_div, aac.parentNode);
          }
        }
      }
    }
  });
  observer.observe(document.body, {childList: true, subtree: true});

  const review_redesign = (node) =>{
    const crs_contentItem = node.querySelectorAll('.cFLREi');
    for (const element of crs_contentItem) {
      element.style.borderWidth = "2px 0px";
      element.style.borderColor = "#E8E5DE";
    }
    const crs_personalInfo = node.querySelectorAll('.hJYLFq');
    for (const element of crs_personalInfo) {
      element.style.display = "none";
    }
    const crs_date = node.querySelectorAll('.gIIhxN');
    for (const element of crs_date) {
      element.style.display = "none";
    }
    const crs_help_parent = node.querySelectorAll('.iiJgQd');
    for (const element of crs_help_parent) {
      element.style.flexWrap = "wrap";
    }
    const crs_helpful = node.querySelectorAll('.hVbTeB');
    for (const element of crs_helpful) {
      element.innerHTML = "Was this review helpful?";
    }
    const crs_like_btn = node.querySelectorAll('.ipgIWW');
    for (const element of crs_like_btn) {
      element.setAttribute("style", "border: 1px solid #E8E5DE; border-radius: 4px; padding: 4px 8px 5px 8px; background: #E8E5DE59; margin-right: 10px;");
    }
    const crs_dislike_btn = node.querySelectorAll('.kGAbXX');
    for (const element of crs_dislike_btn) {
      element.setAttribute("style", "border: 1px solid #E8E5DE; border-radius: 4px; padding: 3px 8px 6px 8px; background: #E8E5DE59; margin-right: 10px;");
    }
    const crs_like_btn_text = node.querySelectorAll('.dqGcxI');
    for (const element of crs_like_btn_text) {
      element.style.margin = "0px";
    }
    const crs_dislike_btn_text = node.querySelectorAll('.hwsZFC');
    for (const element of crs_dislike_btn_text) {
      element.style.margin = "0px";
    }
    // const indicators = node.querySelectorAll('.dMoRVl');
    // for (const indicator of indicators) {
    //   indicator.style.display = "none";
    // }
  }

  const bv_observer = new MutationObserver((mutationsList, bv_observer) => {
    const bv_container = document.querySelector('[data-bv-show="reviews"]');
    if(bv_container){
      const bv_shadowRoot = bv_container.shadowRoot;
      if(bv_shadowRoot){
        bv_observer.disconnect();
        // console.log("BV shadow found: ", bv_shadowRoot.lastChild);
        const bv_header = bv_shadowRoot.querySelector('.oSBfm');
        if(bv_header){
          bv_header.innerHTML = "User Reviews";
          bv_header.setAttribute("style", "font-size: 28px; font-weight: 800 !important; color: #121212; margin-top: 0px; font-family: proxima-nova, sans-serif !important;");
        }

        const sr_observer = new MutationObserver((mutations, obs) => {
          for (const mutation of mutations) {
            // console.log('BV Shadow mutation detected:', mutation);
            if (mutation.type === 'attributes') {
              if(mutation.target.firstChild && 
                mutation.target.firstChild.classList &&
                mutation.target.firstChild.classList.contains('jtRfje')){
                  const cr = mutation.target.querySelector('.dkdwd');
                  if(cr){
                    cr.style.display = "none";
                  }
                  review_redesign(mutation.target);
              }
              if (mutation.target.classList && mutation.target.classList.contains('hoekSN')){
                mutation.target.style.borderBottom = "0px";
                if(!mutation.target.classList.contains('section-yv-review-content')){
                  mutation.target.classList.add('section-yv-review-content');
                }
              }
              if (mutation.target.classList && mutation.target.classList.contains('iNsBHU')){
                if(!mutation.target.classList.contains('section-yv-review-content')){
                  mutation.target.classList.add('section-yv-review-content');
                }
              }
              if (mutation.target.classList && mutation.target.classList.contains('UsOvC')){
                if(!mutation.target.classList.contains('section-yv-review-content')){
                  mutation.target.classList.add('section-yv-review-content');
                }
              }
              if (mutation.target.classList && mutation.target.classList.contains('dLooXP')){
                if(!mutation.target.classList.contains('section-yv-review-content')){
                  mutation.target.classList.add('section-yv-review-content');
                }
              }
            }
            if (mutation.type === 'childList') {
              if (mutation.target.classList && mutation.target.classList.contains("laNxzB")){
                // console.log('BV Shadow mutation detected:', mutation);
                mutation.target.style.borderBottom = "none";
                if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('bv_rating_content2')) {
                  const bv_overAllRating_c = mutation.addedNodes[0];
                  const rating_text = bv_overAllRating_c.querySelector('.lcZrbJ').innerHTML; 
                  const bv_overAllRatingText = bv_overAllRating_c.querySelector('.hXsWl');
                  const bv_overAllRating = bv_overAllRating_c.querySelector('.krTpQg');
                  const bv_stars = bv_overAllRating_c.querySelectorAll('.dYouig ');
                  for (const element of bv_stars) {
                      element.style.width = "25px";
                      element.style.height = "25px";
                  }
                  const bv_review_container = bv_shadowRoot.querySelector('.goTcGM');
                  if(bv_review_container && bv_overAllRating){
                    bv_overAllRating.style.marginTop = "15px";
                    // bv_overAllRating.innerText = rating_text;
                    bv_overAllRating.style.padding = "0px";
                    bv_overAllRating.style.display = "block";
                    bv_overAllRating.style.height = "auto";
                    bv_overAllRating.innerHTML = bv_stars[0].outerHTML + bv_stars[1].outerHTML + bv_stars[2].outerHTML + bv_stars[3].outerHTML + bv_stars[4].outerHTML + `<span style="font-size: 20px; color: black; margin-left: 10px; position: relative; top: -5px;">${rating_text}</span>`;
                    const text = bv_overAllRatingText.cloneNode(true);
                    text.style.fontWeight = "bold";
                    text.style.fontSize = "16px";
                    text.style.color = "#121212";
                    const cloned_bv_overAllRating = bv_overAllRating.cloneNode(true);
                    cloned_bv_overAllRating.appendChild(text);
                    bv_review_container.prepend(cloned_bv_overAllRating);
                    bv_overAllRating_c.style.display = "none";
                  }
                  mutation.addedNodes[0].setAttribute("style", "flex: 2 1 0%;");
                }
                if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('bv_rating_content1')) {
                  // console.log('Removing BV rating content1:', mutation.addedNodes[0]);
                  const ptNode = mutation.addedNodes[0].parentNode.parentNode;
                  const title = mutation.addedNodes[0].querySelector('.bXgJJJ');
                  if(title){
                    title.innerHTML = "Average rating";
                    title.style.padding = "0px 1px 1px";
                    title.style.color = "#121212";
                  }
                  
                  const yuva_bv_modified_container = bv_shadowRoot.querySelector('#yuva_bv_modified_container');
                  if(yuva_bv_modified_container){
                    yuva_bv_modified_container.querySelector('.ratingSnapshot').innerHTML = `${mutation.addedNodes[0].outerHTML}`;
                  }else{
                    const newNode = document.createElement('div');
                    newNode.id = "yuva_bv_modified_container";
                    newNode.setAttribute("style", "display: flex; flex-flow: wrap; position: relative;");
                    newNode.innerHTML = `
                    <div class="bvRatingBreakdown" style="max-width: 650px;">
                    
                    </div>
                    <div class="ratingSnapshot" style="width: 410px;">
                      ${mutation.addedNodes[0].outerHTML}
                    </div>
                    `;
                    ptNode.insertBefore(newNode, mutation.addedNodes[0].parentNode.nextSibling);
                  }
                  mutation.addedNodes[0].style.display = "none";
                }
                if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('bv_rating_content3')) {
                  const title = mutation.addedNodes[0].querySelector('.bXgJJJ');
                  if(title){
                      title.style.padding = "0px";
                      title.style.color = "#121212";
                      title.style.fontSize = "16px";
                  }
                }
              }
              if (mutation.target.classList && mutation.target.classList.contains("goTcGM")){
                if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('goOopm')) {
                  mutation.addedNodes[0].style.display = "none";
                }
                if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('XLlTW')) {
                  // console.log('XLlTW: ', mutation.addedNodes[0]);
                  mutation.addedNodes[0].style.borderBottom = "0px";
                  mutation.addedNodes[0].style.backgroundColor = "white";
                  const title = mutation.addedNodes[0].querySelector('.frEfba');
                  const content = mutation.addedNodes[0].querySelector('.iOWExM');
                  const markContainer = mutation.addedNodes[0].querySelectorAll('.iGDQRC');
                  if(title){
                    title.style.textAlign = "start";
                    title.innerHTML = "What Customers feel about our Products";
                    title.style.color = "#121212";
                    for (const mark of markContainer) {
                      mark.style.minWidth = "25px";
                    }
                  }
                  if(content){
                    content.style.justifyContent = "start";
                  }
                  const ptNode = mutation.addedNodes[0].parentNode;
                  const yuva_bv_modified_container = bv_shadowRoot.querySelector('#yuva_bv_modified_container');
                  if(yuva_bv_modified_container){
                    yuva_bv_modified_container.querySelector('.bvRatingBreakdown').innerHTML = `${mutation.addedNodes[0].outerHTML}`;
                  }else{
                    const newNode = document.createElement('div');
                    newNode.id = "yuva_bv_modified_container";
                    newNode.setAttribute("style", "display: flex; flex-flow: wrap; position: relative;");
                    newNode.innerHTML = `
                    <div class="bvRatingBreakdown" style="max-width: 650px;">
                      ${mutation.addedNodes[0].outerHTML}
                    </div>
                    <div class="ratingSnapshot" style="width: 410px;">

                    </div>
                    `;
                    ptNode.insertBefore(newNode, mutation.addedNodes[0].previousSibling);
                  }
                  mutation.addedNodes[0].style.display = "none";
                }
              }
              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('bOGLXF')){
                mutation.addedNodes[0].style.textAlign = "start";
                mutation.addedNodes[0].style.margin = "4px 1px 1px 20px";
                mutation.addedNodes[0].style.color = "#121212";
              }
              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('dEbCSQ')){
                const photos_ul = mutation.addedNodes[0].querySelector('.cdMMba');
                if (photos_ul){
                  photos_ul.style.justifyContent = "start";
                  photos_ul.style.paddingLeft = "20px";
                }
              }
              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('ibJWVa')){
                mutation.addedNodes[0].style.borderBottom = "0px";
              }
              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('etjtNv')){
                mutation.addedNodes[0].style.border = "2px solid #E8E5DE";
                mutation.addedNodes[0].querySelectorAll('.jKuOos').forEach(d=>{
                  console
                  d.style.display = "none";
                });
              }
              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('UsOvC')){
                // console.log('UsOvC detected:', mutation);
                const bv_rq_container = bv_shadowRoot.querySelector('.yv_bv_rq_tabs');
                if(!bv_rq_container){
                  const mySheet = new CSSStyleSheet();
                  mySheet.replaceSync(`
                      .yv_bv_rq_tabs{
                        display: flex;
                        margin-left: 20px;
                      }
                      .yv_bv_rq_tab.active{
                        background: #006400;
                        color: white;
                        border-radius: 8px 8px 0 0;
                        flex: 1;
                        text-align: center;
                        justify-items: center;
                        padding: 12px 24px;
                        font-size: 18px;
                        font-weight: 600;
                      }
                      .yv_bv_rq_tab{
                        padding: 12px 24px;
                        cursor: pointer;
                        flex: 1;
                        text-align: center;
                        justify-items: center;
                        color: #63656B;
                        font-size: 18px;
                        font-weight: 600;
                      }
                      .section-yv-review-header {
                        display: none;    
                      }

                      /* Collapsible content */
                      .section-yv-review-content {
                        max-height: 0;
                        overflow: auto;
                        transition: max-height 0.45s cubic-bezier(0.4,0,0.2,1), padding 0.45s ease;
                      }
                      .section-yv-review-content.open {
                        max-height: 10000px;
                        overflow: visible;
                      }

                      @media (max-width: 768px) {
                        .yv_bv_rq_tabs{
                          border-bottom: 1px solid #ddd;
                        }
                        .yv_bv_rq_tab{
                          display: none;
                        }
                        .section-yv-review-header {
                          flex: 1;
                          // background: #006A37;
                          // color: white;
                          padding: 16px 20px;
                          font-size: 18px;
                          font-weight: 600;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          cursor: pointer;
                          user-select: none;
                          position: sticky;
                          top: 0;
                          z-index: 10;
                          border-top-left-radius: 8px;
                          border-top-right-radius: 8px;
                        }

                        .section-yv-review-header.active {
                          flex: 1;
                          background: #006A37;
                          color: white;
                          padding: 16px 20px;
                          font-size: 18px;
                          font-weight: 600;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          cursor: pointer;
                          user-select: none;
                          position: sticky;
                          top: 0;
                          z-index: 10;
                          border-top-left-radius: 8px;
                          border-top-right-radius: 8px;
                        }

                        .section-yv-review-header::after {
                          content: '+';
                          width: auto;
                          height: auto;
                          border: none;
                          font-size: 28px;
                          font-weight: 300;
                          transform: none !important;
                        }
                        .section-yv-review-header.active::after { content: '−'; }
                      }
                  `);
                  bv_shadowRoot.adoptedStyleSheets = [...bv_shadowRoot.adoptedStyleSheets, mySheet];
                  const bv_review_questions_button = document.createElement('div');
                  bv_review_questions_button.classList.add('yv_bv_rq_tabs');
                  // bv_review_questions_button.setAttribute('style', 'display: flex; margin-bottom: 20px; border-bottom: 1px solid #ddd;');
                  bv_review_questions_button.innerHTML = `
                    <div id="reviews-tab" class="yv_bv_rq_tab active" >Reviews</div>
                    <div id="questions-tab" class="yv_bv_rq_tab">Questions</div>
                    <div class="section-yv-review-header active" id="review_mobile_button" data-title="Reviews">
                      Reviews
                    </div>
                  `;
                  bvSafeClass(bv_shadowRoot, '.UsOvC', 'add', ['section-yv-review-content','open']);
                  bvSafeClass(bv_shadowRoot, '.hoekSN', 'add', ['section-yv-review-content','open']);
                  bvSafeClass(bv_shadowRoot, '.dLooXP', 'add', ['section-yv-review-content','open']);
                  bvSafeClass(bv_shadowRoot, '.iNsBHU', 'add', ['section-yv-review-content','open']);
                  mutation.addedNodes[0].parentNode.insertBefore(bv_review_questions_button, mutation.addedNodes[0]);
                  bv_review_questions_button.querySelector('#reviews-tab').addEventListener('click', ()=>{
                    bv_review_questions_button.querySelector(".yv_bv_rq_tab.active").classList.remove('active');
                    bv_review_questions_button.querySelector('#reviews-tab').classList.add('active');
                    // bv_shadowRoot.querySelector('#reviews_container').style.display = "block";
                    // bv_shadowRoot.querySelector('.UsOvC').style.display = "block";
                    // bv_shadowRoot.querySelector('.hoekSN').style.display = "block";
                    // bv_shadowRoot.querySelector('.iNsBHU').style.display = "block";
                    // document.querySelector('.bv-qns-ans').style.display = "none";
                    bvSafeClass(bv_shadowRoot, '#reviews_container', 'add', ['open']);
                    bvSafeClass(bv_shadowRoot, '.UsOvC', 'add', ['open']);
                    bvSafeClass(bv_shadowRoot, '.hoekSN', 'add', ['open']);
                    bvSafeClass(bv_shadowRoot, '.iNsBHU', 'add', ['open']);
                    document.querySelector('.bv-qns-ans').classList.remove('open');

                    bv_review_questions_button.querySelector('#review_mobile_button').classList.add('active');
                    document.querySelector('#bv_question_mobile_button').classList.remove('active');
                  });
                  bv_review_questions_button.querySelector('#questions-tab').addEventListener('click', ()=>{
                    bv_review_questions_button.querySelector(".yv_bv_rq_tab.active").classList.remove('active');
                    bv_review_questions_button.querySelector('#questions-tab').classList.add('active');
                    // bv_shadowRoot.querySelector('#reviews_container').style.display = "none";
                    // bv_shadowRoot.querySelector('.UsOvC').style.display = "none";
                    // bv_shadowRoot.querySelector('.hoekSN').style.display = "none";
                    // bv_shadowRoot.querySelector('.iNsBHU').style.display = "none";
                    // document.querySelector('.bv-qns-ans').style.display = "block";
                    bvSafeClass(bv_shadowRoot, '#reviews_container', 'remove', ['open']);
                    bvSafeClass(bv_shadowRoot, '.UsOvC', 'remove', ['open']);
                    bvSafeClass(bv_shadowRoot, '.hoekSN', 'remove', ['open']);
                    bvSafeClass(bv_shadowRoot, '.iNsBHU', 'remove', ['open']);
                    document.querySelector('.bv-qns-ans').classList.add('open');

                    document.querySelector('#bv_question_mobile_button').classList.add('active');
                    bv_review_questions_button.querySelector('#review_mobile_button').classList.remove('active');
                  });
                  bv_review_questions_button.querySelector('#review_mobile_button').addEventListener('click', (e) => {
                    const header = e.target;
                    if (header){
                      const isActive = header.classList.contains('active');
                      // const content = header.nextElementSibling;
                      // Close all
                      bv_review_questions_button.querySelectorAll('.section-yv-review-header').forEach(h => {
                        h.classList.remove('active');
                        bvSafeClass(bv_shadowRoot, '.UsOvC', 'remove', ['open']);
                        bvSafeClass(bv_shadowRoot, '.hoekSN', 'remove', ['open']);
                        bvSafeClass(bv_shadowRoot, '.dLooXP', 'remove', ['open']);
                        bvSafeClass(bv_shadowRoot, '.iNsBHU', 'remove', ['open']);
                        // h.nextElementSibling.classList.remove('open');
                      });
                    
                      // Open clicked one
                      if (!isActive) {
                        header.classList.add('active');
                        bvSafeClass(bv_shadowRoot, '.UsOvC', 'add', ['open']);
                        bvSafeClass(bv_shadowRoot, '.hoekSN', 'add', ['open']);
                        bvSafeClass(bv_shadowRoot, '.dLooXP', 'add', ['open']);
                        bvSafeClass(bv_shadowRoot, '.iNsBHU', 'add', ['open']);
                        // content.classList.add('open');
                      }
                    }
                  });
                  document.querySelector('#bv_question_mobile_button').addEventListener('click', (e)=>{
                    const header = e.target;
                    if (header){
                      const isActive = header.classList.contains('active');
                      // Close all
                      document.querySelectorAll('.section-yv-question-header').forEach(h => {
                        h.classList.remove('active');
                        document.querySelector('.bv-qns-ans').classList.remove('open');
                      });
                    
                      // Open clicked one
                      if (!isActive) {
                        header.classList.add('active');
                        document.querySelector('.bv-qns-ans').classList.add('open');
                      }
                    }
                  });
                }

              }
              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('dLooXP')){
                
                const crs = mutation.addedNodes[0].querySelectorAll('.dkdwd');
                for (const cr of crs) {
                  cr.style.display = "none";
                }
                review_redesign(mutation.addedNodes[0]);
              }

              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].id == "bv-rnr-portal") {
                const photo_modal = mutation.addedNodes[0].querySelector('#photoModal');
                const photo_modal_top_bar_mobile = mutation.addedNodes[0].querySelector('.cZVDl');
                photo_modal.setAttribute("style", "max-height: 70vh; margin-top: 140px;");
                const mediaQuery = window.matchMedia('(max-width: 767px)');
                if(mediaQuery.matches){
                  photo_modal_top_bar_mobile.style.marginTop = "70px";
                }
              }

              if(mutation.addedNodes.length > 0 && 
                mutation.addedNodes[0].classList && 
                mutation.addedNodes[0].childNodes && 
                mutation.addedNodes[0].childNodes.length > 0 &&
                mutation.addedNodes[0].childNodes[0].classList &&
                mutation.addedNodes[0].childNodes[0].classList.contains('jtRfje')){
                // console.log('jtRfje detected:', mutation);

                const cr = mutation.addedNodes[0].childNodes[0].querySelector('.dkdwd');
                // console.log('cr detected:', cr);

                if(cr){
                  cr.style.display = "none";
                }

                review_redesign(mutation.addedNodes[0]);
              }

              // if(mutation.target.firstChild && 
              //   mutation.target.firstChild.classList &&
              //   mutation.target.firstChild.classList.contains('jtRfje')){
              //     const cr = mutation.target.querySelector('.dkdwd');
              //     if(cr){
              //       cr.style.display = "none";
              //     }
              // }
              
              // if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].hasAttribute('data-bv-show') && mutation.addedNodes[0].getAttribute('data-bv-show') === 'review-summaries') {
              //   console.log('Removing review summaries:', mutation.addedNodes[0]);
              //   const bv_ai_summary = mutation.addedNodes[0].cloneNode(true);
              //   // console.log('Cloned BV AI Summary:', bv_ai_summary);
              //   const bv_ai_summary_dest = bv_shadowRoot.querySelector('.bv_rating_content2');
              //   console.log('BV AI Summary Destination:', bv_ai_summary.outerHTML);
              //   mutation.addedNodes[0].style.display = "none";
              //   // bv_ai_summary_dest.innerHTML = bv_ai_summary.outerHTML
              // }
              if (mutation.addedNodes.length > 0 && mutation.addedNodes[0].localName === "swat-review-summaries-wrapper") {
                const wrapperElement = mutation.addedNodes[0];

                // SSI-1941: Function to style the tooltip popup
                const styleTooltipComponent = (tooltipComponent) => {
                  if (!tooltipComponent) return;

                  // Wait for shadow root to be available
                  const waitForShadowRoot = setInterval(() => {
                    if (tooltipComponent.shadowRoot) {
                      clearInterval(waitForShadowRoot);

                      // Inject CSS styles into the tooltip shadow DOM
                      const tooltipStyles = document.createElement('style');
                      tooltipStyles.id = 'ssi-1941-tooltip-styles';
                      tooltipStyles.textContent = `
                        .swat-hosted-tooltip {
                          background-color: #ffffff !important;
                          position: fixed !important;
                          top: 50% !important;
                          left: 50% !important;
                          transform: translate(-50%, -50%) !important;
                          max-width: 500px !important;
                          max-height: 80vh !important;
                          width: auto !important;
                          min-width: 300px !important;
                          overflow: hidden !important;
                          z-index: 2147483647 !important;
                          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
                          border-radius: 8px !important;
                          padding: 20px !important;
                          box-sizing: border-box !important;
                        }
                        .swat-hosted-tooltip-content {
                          color: #121212 !important;
                          background-color: transparent !important;
                          max-height: calc(80vh - 60px) !important;
                          overflow-y: auto !important;
                          overflow-x: hidden !important;
                        }
                        .swat-hosted-close-btn {
                          position: absolute !important;
                          top: 10px !important;
                          right: 10px !important;
                          background: #046A38 !important;
                          color: white !important;
                          border: none !important;
                          border-radius: 50% !important;
                          width: 32px !important;
                          height: 32px !important;
                          cursor: pointer !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          z-index: 2147483648 !important;
                        }
                        .swat-hosted-close-btn svg,
                        .swat-hosted-close-btn path {
                          fill: white !important;
                          stroke: white !important;
                          stroke-width: 2px !important;
                        }
                        .swat-hosted-close-btn svg {
                          width: 16px !important;
                          height: 16px !important;
                        }
                        @media (max-width: 767px) {
                          .swat-hosted-tooltip {
                            width: 95vw !important;
                            max-width: 95vw !important;
                            min-width: auto !important;
                            max-height: 70vh !important;
                            padding: 15px !important;
                          }
                          .swat-hosted-tooltip-content {
                            max-height: calc(70vh - 60px) !important;
                          }
                        }
                      `;

                      // Only add styles if not already present
                      if (!tooltipComponent.shadowRoot.querySelector('#ssi-1941-tooltip-styles')) {
                        tooltipComponent.shadowRoot.appendChild(tooltipStyles);
                      }

                      // Also apply inline styles to the tooltip element for higher specificity
                      const tooltip = tooltipComponent.shadowRoot.querySelector('.swat-hosted-tooltip');
                      if (tooltip) {
                        const isMobile = window.matchMedia('(max-width: 767px)').matches;
                        tooltip.style.cssText = `
                          background-color: #ffffff !important;
                          position: fixed !important;
                          top: 50% !important;
                          left: 50% !important;
                          transform: translate(-50%, -50%) !important;
                          max-width: ${isMobile ? '95vw' : '500px'} !important;
                          max-height: ${isMobile ? '70vh' : '80vh'} !important;
                          width: ${isMobile ? '95vw' : 'auto'} !important;
                          min-width: ${isMobile ? 'auto' : '300px'} !important;
                          overflow: hidden !important;
                          z-index: 2147483647 !important;
                          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
                          border-radius: 8px !important;
                          padding: 20px !important;
                          box-sizing: border-box !important;
                        `;

                        // Style the content area to have the single scrollbar
                        const tooltipContent = tooltipComponent.shadowRoot.querySelector('.swat-hosted-tooltip-content');
                        if (tooltipContent) {
                          tooltipContent.style.cssText = `
                            color: #121212 !important;
                            background-color: transparent !important;
                            max-height: calc(${isMobile ? '70vh' : '80vh'} - 60px) !important;
                            overflow-y: auto !important;
                            overflow-x: hidden !important;
                          `;
                        }

                        // Style the close button
                        const closeBtn = tooltipComponent.shadowRoot.querySelector('.swat-hosted-close-btn');
                        if (closeBtn) {
                          closeBtn.style.cssText = `
                            position: absolute !important;
                            top: 10px !important;
                            right: 10px !important;
                            background: #046A38 !important;
                            color: white !important;
                            border: none !important;
                            border-radius: 50% !important;
                            width: 32px !important;
                            height: 32px !important;
                            cursor: pointer !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            z-index: 2147483648 !important;
                          `;
                          // Style the SVG inside close button for white X
                          const closeBtnSvg = closeBtn.querySelector('svg');
                          if (closeBtnSvg) {
                            closeBtnSvg.style.cssText = 'width: 16px !important; height: 16px !important;';
                            const paths = closeBtnSvg.querySelectorAll('path, line, polyline');
                            paths.forEach(p => {
                              p.style.cssText = 'fill: white !important; stroke: white !important; stroke-width: 2px !important;';
                            });
                          }
                        }
                      }
                    }
                  }, 50);

                  // Clear interval after 5 seconds to prevent memory leaks
                  setTimeout(() => clearInterval(waitForShadowRoot), 5000);
                };

                // SSI-1941: Check if tooltip component already exists in the wrapper
                const checkExistingTooltip = () => {
                  if (wrapperElement.shadowRoot) {
                    const existingTooltip = wrapperElement.shadowRoot.querySelector('swat-hosted-tooltip-component');
                    if (existingTooltip) {
                      styleTooltipComponent(existingTooltip);
                    }
                  }
                };

                // Wait for wrapper's shadow root and check for existing tooltip
                const waitForWrapperShadow = setInterval(() => {
                  if (wrapperElement.shadowRoot) {
                    clearInterval(waitForWrapperShadow);
                    checkExistingTooltip();
                  }
                }, 50);
                setTimeout(() => clearInterval(waitForWrapperShadow), 5000);

                const ai_summary_obs = new MutationObserver((mutations, obs) => {
                  for (const mutation of mutations) {
                    if (mutation.addedNodes.length > 0) {
                      // SSI-1941: Handle swat-hosted-tooltip-component for inline_rating popup
                      const tooltipComponent = Array.from(mutation.addedNodes).find(node =>
                        node.localName === "swat-hosted-tooltip-component"
                      );
                      if (tooltipComponent) {
                        // SSI-1941: Use the shared function to style the tooltip
                        styleTooltipComponent(tooltipComponent);
                      }

                      const addedDivs = Array.from(mutation.addedNodes).find(node =>
                        node.localName === "swat-review-summaries"
                      );
                      if (addedDivs) {
                        // Note: Don't disconnect - need to keep watching for swat-hosted-tooltip-component (SSI-1941)
                        // SSI-1941: Style AI summary content for inline display in reviews section (not as modal popup)
                        if (addedDivs.shadowRoot) {
                          const inlineStyles = document.createElement('style');
                          inlineStyles.textContent = `
                            .swat-review-summary-container-border {
                              background-color: #ffffff !important;
                              border-radius: 8px !important;
                              padding: 15px !important;
                            }
                            .swat-review-summary-container-border .swat-hosted-summaries-heading,
                            .swat-review-summary-container-border .swat-hosted-summary-text,
                            .swat-review-summary-container-border .swat-hosted-feedback-buttons,
                            .swat-review-summary-container-border .swat-hosted-show-more-link {
                              color: #121212 !important;
                              background-color: transparent !important;
                            }
                            .swat-review-summary-container-border .swat-hosted-summary-text {
                              line-height: 1.5 !important;
                            }
                          `;
                          addedDivs.shadowRoot.appendChild(inlineStyles);
                        }
                        const swat_review_summary_container_border_obs = new MutationObserver((mutations, obs) => {
                          for (const mutation of mutations) {
                            if (mutation.addedNodes.length > 0) {
                              const ai_sum_div = Array.from(mutation.addedNodes).find(node => 
                                node.classList && node.classList.contains("swat-review-summary-container-border")
                              );
                              if (ai_sum_div) {
                                obs.disconnect();
                                // SSI-1941: Removed automatic modal popup display when scrolling to reviews section
                                // The AI summary popup should ONLY appear when clicking the dropdown arrow at the top
                                // The content will remain visible inline in the reviews section without modal behavior
                                // console.log("Found swat-review-summary-container-border (inline display only): ", ai_sum_div);
                              }
                            }
                          }
                        });

                        swat_review_summary_container_border_obs.observe(addedDivs.shadowRoot, { childList: true, subtree: true, attributes: true });
                        // if (swat_review_summary_container_border) {
                        //   console.log("Found swat-review-summary-container-border: ", swat_review_summary_container_border);
                        // }
                      }
                    }
                  }
                });
                ai_summary_obs.observe(mutation.addedNodes[0].shadowRoot, { childList: true, subtree: true, attributes: true });
              }
            }
          }
        });

        sr_observer.observe(bv_shadowRoot, { childList: true, subtree: true, attributes: true });
        const bv_review_container = bv_shadowRoot.querySelector('.goTcGM');
        const bv_overAllRating = bv_shadowRoot.querySelector('.bv_rating_content2');
        // console.log("BV review container: ", bv_review_container);
        // console.log("BV overall rating: ", bv_overAllRating);
        if(bv_review_container && bv_overAllRating){
          const cloned_bv_overAllRating = bv_overAllRating.cloneNode(true);
          // console.log("Cloned BV overall rating: ", cloned_bv_overAllRating);
          bv_review_container.prepend(cloned_bv_overAllRating);
        }
      }
    }
  });

  const config = { childList: true, subtree: true, attributes: true, characterData: true };
  bv_observer.observe(document.body, config);

  // SSI-1941: Document-level observer for swat-review-summaries-wrapper (inline rating popup)
  // This wrapper is added directly to the document, not inside BazaarVoice shadow DOM
  const styleTooltipPopup = (tooltipComponent) => {
    if (!tooltipComponent) return;

    const waitForShadow = setInterval(() => {
      if (tooltipComponent.shadowRoot) {
        clearInterval(waitForShadow);

        // Only add styles if not already present
        if (tooltipComponent.shadowRoot.querySelector('#ssi-1941-tooltip-styles')) return;

        // Inject CSS styles
        const tooltipStyles = document.createElement('style');
        tooltipStyles.id = 'ssi-1941-tooltip-styles';
        tooltipStyles.textContent = `
          .swat-hosted-tooltip {
            background-color: #ffffff !important;
            position: fixed !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%) !important;
            max-width: 500px !important;
            max-height: 80vh !important;
            width: auto !important;
            min-width: 300px !important;
            overflow: hidden !important;
            z-index: 2147483647 !important;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
            border-radius: 8px !important;
            padding: 20px !important;
            box-sizing: border-box !important;
          }
          .swat-hosted-tooltip-content {
            color: #121212 !important;
            background-color: transparent !important;
            max-height: calc(80vh - 60px) !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
          }
          .swat-hosted-close-btn {
            position: absolute !important;
            top: 10px !important;
            right: 10px !important;
            background: #046A38 !important;
            color: white !important;
            border: none !important;
            border-radius: 50% !important;
            width: 32px !important;
            height: 32px !important;
            cursor: pointer !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            z-index: 2147483648 !important;
          }
          .swat-hosted-close-btn svg,
          .swat-hosted-close-btn path {
            fill: white !important;
            stroke: white !important;
            stroke-width: 2px !important;
          }
          .swat-hosted-close-btn svg {
            width: 16px !important;
            height: 16px !important;
          }
          @media (max-width: 767px) {
            .swat-hosted-tooltip {
              width: 95vw !important;
              max-width: 95vw !important;
              min-width: auto !important;
              max-height: 70vh !important;
              padding: 15px !important;
            }
            .swat-hosted-tooltip-content {
              max-height: calc(70vh - 60px) !important;
            }
          }
        `;
        tooltipComponent.shadowRoot.appendChild(tooltipStyles);

        // Apply inline styles for higher specificity
        const tooltip = tooltipComponent.shadowRoot.querySelector('.swat-hosted-tooltip');
        if (tooltip) {
          const isMobile = window.matchMedia('(max-width: 767px)').matches;
          tooltip.style.cssText = `
            background-color: #ffffff !important;
            position: fixed !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%) !important;
            max-width: ${isMobile ? '95vw' : '500px'} !important;
            max-height: ${isMobile ? '70vh' : '80vh'} !important;
            width: ${isMobile ? '95vw' : 'auto'} !important;
            min-width: ${isMobile ? 'auto' : '300px'} !important;
            overflow: hidden !important;
            z-index: 2147483647 !important;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
            border-radius: 8px !important;
            padding: 20px !important;
            box-sizing: border-box !important;
          `;

          // Style the content area to have the single scrollbar
          const tooltipContent = tooltipComponent.shadowRoot.querySelector('.swat-hosted-tooltip-content');
          if (tooltipContent) {
            tooltipContent.style.cssText = `
              color: #121212 !important;
              background-color: transparent !important;
              max-height: calc(${isMobile ? '70vh' : '80vh'} - 60px) !important;
              overflow-y: auto !important;
              overflow-x: hidden !important;
            `;
          }

          // Style the close button
          const closeBtn = tooltipComponent.shadowRoot.querySelector('.swat-hosted-close-btn');
          if (closeBtn) {
            closeBtn.style.cssText = `
              position: absolute !important;
              top: 10px !important;
              right: 10px !important;
              background: #046A38 !important;
              color: white !important;
              border: none !important;
              border-radius: 50% !important;
              width: 32px !important;
              height: 32px !important;
              cursor: pointer !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              z-index: 2147483648 !important;
            `;
            // Style the SVG inside close button for white X
            const closeBtnSvg = closeBtn.querySelector('svg');
            if (closeBtnSvg) {
              closeBtnSvg.style.cssText = 'width: 16px !important; height: 16px !important;';
              const paths = closeBtnSvg.querySelectorAll('path, line, polyline');
              paths.forEach(p => {
                p.style.cssText = 'fill: white !important; stroke: white !important; stroke-width: 2px !important;';
              });
            }
          }
        }
      }
    }, 50);
    setTimeout(() => clearInterval(waitForShadow), 5000);
  };

  const swatWrapperObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.localName === 'swat-review-summaries-wrapper') {
            // Found the wrapper, now watch its shadow root for the tooltip component
            const waitForWrapperShadow = setInterval(() => {
              if (node.shadowRoot) {
                clearInterval(waitForWrapperShadow);

                // Check for existing tooltip
                const existingTooltip = node.shadowRoot.querySelector('swat-hosted-tooltip-component');
                if (existingTooltip) {
                  styleTooltipPopup(existingTooltip);
                }

                // Watch for tooltip being added
                const tooltipObserver = new MutationObserver((tooltipMutations) => {
                  for (const tm of tooltipMutations) {
                    if (tm.addedNodes.length > 0) {
                      for (const addedNode of tm.addedNodes) {
                        if (addedNode.nodeType === 1 && addedNode.localName === 'swat-hosted-tooltip-component') {
                          styleTooltipPopup(addedNode);
                        }
                      }
                    }
                  }
                });
                tooltipObserver.observe(node.shadowRoot, { childList: true, subtree: true });
              }
            }, 50);
            setTimeout(() => clearInterval(waitForWrapperShadow), 5000);
          }
        }
      }
    }
  });
  swatWrapperObserver.observe(document.body, { childList: true, subtree: true });

  // SSI-1941: Also check if wrapper already exists on page load
  const existingWrapper = document.querySelector('swat-review-summaries-wrapper');
  if (existingWrapper) {
    const waitForExistingShadow = setInterval(() => {
      if (existingWrapper.shadowRoot) {
        clearInterval(waitForExistingShadow);
        const existingTooltip = existingWrapper.shadowRoot.querySelector('swat-hosted-tooltip-component');
        if (existingTooltip) {
          styleTooltipPopup(existingTooltip);
        }
      }
    }, 50);
    setTimeout(() => clearInterval(waitForExistingShadow), 5000);
  }

  // SSI-1941: Make clicking on rating (stars/text, not the dropdown arrow) scroll to reviews section
  const setupRatingClickToScroll = () => {
    // Find inline rating containers anywhere on the page (in product info area)
    const inlineRatings = document.querySelectorAll('[data-bv-show="inline_rating"]');

    inlineRatings.forEach(ratingContainer => {
      // Skip if already processed
      if (ratingContainer.dataset.scrollHandlerAdded) return;
      ratingContainer.dataset.scrollHandlerAdded = 'true';

      // Use capturing phase to intercept before BazaarVoice handlers
      ratingContainer.addEventListener('click', (event) => {
        // If the click was on the chevron/dropdown button, let BazaarVoice handle the popup
        const chevronBtn = event.target.closest('.bv_reviewSummaryChevron') ||
                           event.target.closest('[class*="chevron"]') ||
                           event.target.closest('[class*="Chevron"]') ||
                           event.target.closest('button');
        if (chevronBtn) {
          return; // Let BazaarVoice handle the popup
        }

        // Check if click was on the stars or review count text (not the chevron)
        const clickedOnStars = event.target.closest('.bv_stars_component_container') ||
                               event.target.closest('[class*="stars"]') ||
                               event.target.closest('.bv_text') ||
                               event.target.closest('.bv_numReviews_text') ||
                               event.target.closest('[class*="review"]');

        if (clickedOnStars) {
          // Prevent BazaarVoice from handling this click
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          // Find the reviews section with multiple possible selectors
          const reviewsSection = document.querySelector('.section-bazaar-voice-review') ||
                                 document.querySelector('[data-bv-show="reviews"]') ||
                                 document.querySelector('[id*="bazaar_voice_review"]') ||
                                 document.querySelector('[class*="bazaar-voice"]') ||
                                 document.querySelector('.bv-reviews-container') ||
                                 document.querySelector('#bv-reviews');

          if (reviewsSection) {
            // Scroll smoothly to reviews section with offset for sticky header
            const headerOffset = 100;
            const elementPosition = reviewsSection.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      }, true); // Use capturing phase
    });
  };

  // Run after a delay to ensure BazaarVoice has rendered (only on PDP pages)
  const isPDP = window.location.pathname.includes('/products/');
  if (isPDP) {
    setTimeout(setupRatingClickToScroll, 2000);
    setTimeout(setupRatingClickToScroll, 4000); // Extra attempt for slow loading
    // Also run on any DOM changes in case the rating loads later
    const ratingObserver = new MutationObserver(() => {
      setupRatingClickToScroll();
    });
    ratingObserver.observe(document.body, { childList: true, subtree: true });
    // Stop observing after 15 seconds to avoid performance impact
    setTimeout(() => ratingObserver.disconnect(), 15000);
  }

  // SSI-1941: On collection pages, clicking stars should navigate to PDP reviews section
  const isCollectionPage = window.location.pathname.includes('/collections/');
  if (isCollectionPage) {
    const setupCollectionRatingClick = () => {
      // Find all product cards with inline ratings
      const productCards = document.querySelectorAll('.yv-product-card, .product-card, [class*="product-card"], .grid__item');

      productCards.forEach(card => {
        // Skip if already processed
        if (card.dataset.ratingClickAdded) return;
        card.dataset.ratingClickAdded = 'true';

        // Find the inline rating in this card
        const inlineRating = card.querySelector('[data-bv-show="inline_rating"]');
        if (!inlineRating) return;

        // Find the product link to get the URL
        const productLink = card.querySelector('a[href*="/products/"]');
        if (!productLink) return;

        const productUrl = productLink.getAttribute('href');

        // Add click handler to the rating container
        inlineRating.addEventListener('click', (event) => {
          // Don't intercept if clicking the chevron/dropdown for AI summary
          const chevronBtn = event.target.closest('.bv_reviewSummaryChevron') ||
                             event.target.closest('[class*="chevron"]') ||
                             event.target.closest('[class*="Chevron"]') ||
                             event.target.closest('button');
          if (chevronBtn) return;

          // Check if click was on stars or review count
          const clickedOnStars = event.target.closest('.bv_stars_component_container') ||
                                 event.target.closest('[class*="stars"]') ||
                                 event.target.closest('.bv_text') ||
                                 event.target.closest('.bv_numReviews_text') ||
                                 event.target.closest('.bv_main_container');

          if (clickedOnStars) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            // Navigate to PDP with #reviews hash
            window.location.href = productUrl + '#reviews';
          }
        }, true); // Use capturing phase
      });
    };

    // Run after delay to ensure BazaarVoice has rendered
    setTimeout(setupCollectionRatingClick, 2000);
    setTimeout(setupCollectionRatingClick, 4000);
    // Also run on DOM changes
    const collectionRatingObserver = new MutationObserver(() => {
      setupCollectionRatingClick();
    });
    collectionRatingObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => collectionRatingObserver.disconnect(), 15000);
  }

  // SSI-1941: On PDP, check for #reviews hash and scroll to reviews section on page load
  if (isPDP && window.location.hash === '#reviews') {
    const scrollToReviewsOnLoad = () => {
      const reviewsSection = document.querySelector('.section-bazaar-voice-review') ||
                             document.querySelector('[data-bv-show="reviews"]') ||
                             document.querySelector('[id*="bazaar_voice_review"]') ||
                             document.querySelector('[class*="bazaar-voice"]') ||
                             document.querySelector('.bv-reviews-container') ||
                             document.querySelector('#bv-reviews');

      if (reviewsSection) {
        const headerOffset = 100;
        const elementPosition = reviewsSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        return true;
      }
      return false;
    };

    // Try scrolling after different delays to handle async content loading
    setTimeout(() => {
      if (!scrollToReviewsOnLoad()) {
        setTimeout(() => {
          if (!scrollToReviewsOnLoad()) {
            setTimeout(scrollToReviewsOnLoad, 3000);
          }
        }, 1500);
      }
    }, 500);
  }
})